import Wrapper from '../Wrapper/Wrapper';
import React from 'react';
import PropTypes from 'prop-types';

const SolidLineHeader = ({ isDesktop }) => (
  <Wrapper>
    <Wrapper textAlign="center" margin="0 10px 0 10px" lineHeight="0px" borderTop="2px solid black">
      <Wrapper
        font={'"Avenir", "Arial", sans-serif'}
        fontSize={isDesktop ? '30px' : '15px'}
        letterSpacing="1px"
        fontWeight="900"
        uppercase
        display="inline"
        bgColor="#FFFFFF"
        padding="0 20px"
      >
        latest press
      </Wrapper>
    </Wrapper>
  </Wrapper>
);

SolidLineHeader.defaultProps = {
  isDesktop: false
};

SolidLineHeader.propTypes = {
  isDesktop: PropTypes.bool
};

export default SolidLineHeader;
